import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useEditTradingOfferOperationStatusModal } from '../context/EditTradingOfferOperationStatusModalContext';

const EditTradingOfferOperationStatusModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useEditTradingOfferOperationStatusModal();

  return (
    <Modal.Header className="border-bottom">
      <h5 className="modal-title mb-0">{t('Edit')}</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default EditTradingOfferOperationStatusModalHeader;
